import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { TermsSEO } from '../components/SEO';

const Terms = () => {
  return (
    <div className="min-h-screen bg-white">
      <TermsSEO />
      <Header />
      
      <div className="max-w-4xl mx-auto px-6 md:px-12 py-16">
        <h1 className="font-playfair text-4xl md:text-5xl font-bold mb-12 text-[#1a1a1a]">
          Terms of Service
        </h1>
        
        <div className="space-y-8 font-manrope text-sm">
          <section>
            <h2 className="font-playfair text-2xl font-bold mb-4 text-[#1a1a1a]">1. Service Overview</h2>
            <p className="text-[#737373]">
              Media Coverage Marketplace connects clients with verified media outlets for article placements. We facilitate the publication process but do not guarantee editorial approval.
            </p>
          </section>
          
          <section>
            <h2 className="font-playfair text-2xl font-bold mb-4 text-[#1a1a1a]">2. Editorial Outcome Policy</h2>
            <p className="text-[#737373] mb-2">
              All publications are subject to editorial approval by the respective media outlet. If content is rejected:
            </p>
            <ul className="list-disc list-inside text-[#737373] space-y-1 ml-4">
              <li>Client may choose a replacement outlet of equal value, OR</li>
              <li>Receive a full refund of the publication fee</li>
              <li>Writing service fees are non-refundable once draft is delivered</li>
            </ul>
          </section>
          
          <section>
            <h2 className="font-playfair text-2xl font-bold mb-4 text-[#1a1a1a]">3. Payment Terms</h2>
            <p className="text-[#737373]">
              All payments must be made upfront via Razorpay. Prices include 18% GST. Invoices are generated automatically and available for download.
            </p>
          </section>
          
          <section>
            <h2 className="font-playfair text-2xl font-bold mb-4 text-[#1a1a1a]">4. Content Guidelines</h2>
            <p className="text-[#737373]">
              Clients must ensure content complies with individual publication guidelines. Promotional or overly commercial content may be rejected. We recommend newsworthy angles focused on business developments, announcements, or thought leadership.
            </p>
          </section>
          
          <section>
            <h2 className="font-playfair text-2xl font-bold mb-4 text-[#1a1a1a]">5. Turnaround Times</h2>
            <p className="text-[#737373]">
              TAT windows are estimates and depend on editorial calendars. Timelines begin after content submission and approval.
            </p>
          </section>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default Terms;